import React from "react";

// fetchAddress.js - API functions for address management

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

// Get cities list
export const fetchCity = async () => {
  try {
    const response = await fetch(`${API_URL}/api/Address/getCitys`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      // Try to get error message from response
      const errorText = await response.text();
      throw new Error(errorText || 'fetchCity failed');
    }
    
    return await response.json();
  } catch (err) {
    throw err;
  }
};

// Optimized street search function for large datasets
export const searchStreets = async (query) => {
  if (!query || query.length < 2) return [];
  
  try {
    // Add error handling and timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
    
    const response = await fetch(
      `${API_URL}/api/Address/searchStreets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: query,
          limit: 20 // Limit results to improve performance
        }),
        signal: controller.signal
      }
    );
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to search streets');
    }
    
    return await response.json();
  } catch (error) {
    // Handle abort error differently
    if (error.name === 'AbortError') {
      return [];
    }
    
    return [];
  }
};

// Get popular/common streets (for initial display)
export const fetchStreets = async () => {
  try {
    const response = await fetch(`${API_URL}/api/Address/getStreets`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit: 100 // Only get the most popular streets for initial display
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'fetchStreets failed');
    }
    
    return await response.json();
  } catch (err) {
    throw err;
  }
};